import React, { useState, useEffect } from "react";
import "../App.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";//npm install --save @fortawesome/react-fontawesome @fortawesome/fontawesome-svg-core @fortawesome/free-brands-svg-icons
import { faYoutube, faFacebook, faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons";
import Services from './Services'
import { Table } from "react-bootstrap";
import { RotatingLines } from "react-loader-spinner";

import { hospitalcodedata } from './hospitalcodedata';

const moment = require("moment");

const social_style = { background: "#edf5fe", color: "eb3223", padding: "5px", marginLeft: "5px", marginRight: "5px" }

const hospitalList1 = [["DME", "GMH-TPT"],["DME", "MCH-VJA"],["DME", "RIMS-ONG"],["DME", "RIMS-SKLM"],
  ["DME", "RIMS-KDP"],["DME", "GVH-VSKP"],["DME", "KGH-VSKP"],["DME", "GGH-GTR"],["DME", "GGH-KKD"],
  ["DME", "GGH-ATP"],["DME", "MCHSPSR-NLR"],["DME", "GGH-KNL"],["DME", "DH-NDL"],["DME", "DH-MTM"],
  ["DME", "DH-RJY"],["DME", "MCH-ELR"],["VVP", "DH-HPUR"],["VVP", "DH-TNL"],["VVP", "DH-PDTR"],
  ["VVP", "DH-AKP"],["VVP", "MCH-ONG"],["VVP", "MCH-VZG"],["VVP", "MCH-ADONI"],];

const hospitalList = [
  ["DME", "GMH-TPT"], ["DME", "MCH-VJA"], ["DME", "RIMS-SKLM"], ["DME", "RIMS-KDP"],
  ["DME", "GVH-VSKP"], ["DME", "KGH-VSKP"], ["DME", "GGH-GTR"], ["DME", "DH-MTM"],
  ["DME", "DH-RJY"], ["DME", "MCH-ELR"], ["VVP", "DH-HPUR"], ["VVP", "DH-TNL"],
  ["VVP", "DH-PDTR"], ["VVP", "DH-AKP"]
];


// AllHospitalsData Component
const AllHospitalsData = () => {

  const [loading, setLoading] = useState(false);
  const [tcpDataMap, setTcpDataMap] = useState({});

  useEffect(() => {
    fetchAllHospitalData();
  }, []);

  const fetchAllHospitalData = () => {
    setTcpDataMap({});
    hospitalList.forEach(([type, code]) => loadHospitalData(type, code));
  };

  const isValidDate = (dateStr, format) => moment(dateStr, format, true).isValid();

  const loadHospitalData = async (type, code) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("hospital_type", type);
    formData.append("hospital_code", code);

    try {
      const res = await Services.getHospitalsdataByHospitalwise(formData);
      if (res.status !== 200) throw new Error("Invalid status");

      const finalData = processTcpData(
        res.data?.status ? res.data.hospitaldata : [],
        type,
        code
      );

      setTcpDataMap(prev => ({...prev,[`${type}_${code}`]: finalData,}));
      
    } catch (err) {
      alert("Something went wrong: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const processTcpData = (resdata, type, code) => {
    const totalTcpList = [], dischargedTcpList = [], inhospitalTcpList = [];
    const activeTcpList = [], strapremoveTcpList = [], outgateTcpList = [];

    let updatedDateTime = "-";

    for (const item of resdata) {
      if (item.hospital_type === type && item.hospital_code === code) {
        totalTcpList.push(item);

        if (item.patient_status === "IN HOSPITAL") {
          inhospitalTcpList.push(item);
          if (item.tag_alertType_id === "33") strapremoveTcpList.push(item);
          else if (item.tag_alertType_id === "50") outgateTcpList.push(item);
          else activeTcpList.push(item);
        } else if (item.patient_status === "DISCHARGE") {
          dischargedTcpList.push(item);
        }
      }
    }

    if (totalTcpList.length > 0) {
      totalTcpList.sort((a, b) => a.tag_tagid - b.tag_tagid);
      dischargedTcpList.sort((a, b) => a.tag_tagid - b.tag_tagid);
      inhospitalTcpList.sort((a, b) => a.tag_tagid - b.tag_tagid);
      activeTcpList.sort((a, b) => a.tag_tagid - b.tag_tagid);
      strapremoveTcpList.sort((a, b) => a.tag_tagid - b.tag_tagid);
      outgateTcpList.sort((a, b) => a.tag_tagid - b.tag_tagid);

      const dates = totalTcpList.map(i => {
        const [date, time] = i.tag_last_inserted_time.split(" ");
        if (!isValidDate(date, "DD-MM-YYYY")) return null;
        const [d, m, y] = date.split("-");
        return `${y}/${m}/${d} ${time}`;
      }).filter(Boolean).sort((a, b) => new Date(b) - new Date(a));

      if (dates.length > 0) {
        const [fdate, ftime] = dates[0].split(" ");
        if (isValidDate(fdate, "YYYY/MM/DD")) {
          const [y, m, d] = fdate.split("/");
          updatedDateTime = `${d}-${m}-${y} ${ftime}`;
        }
      }
    }

    return {
      hospital_type: type,
      hospital_code: code,
      lastupdated: updatedDateTime,
      grandtotalTcp: totalTcpList,
      dischargedTCP: dischargedTcpList,
      inhospitalTCP: inhospitalTcpList,
      activeTcp: activeTcpList,
      strapRemoveTcp: strapremoveTcpList,
      outGateTcp: outgateTcpList,
    };
  };
    return (
        <div className="full_frame_center">
            <div className="full_frame_center">

                {loading ? (
                    <div className="center_center" style={{ width: "100%", display: "flex" }}>
                        <RotatingLines width="50px" height="50px" strokeColor="red" strokeWidth="8"
                            animationDuration="0.75" visible={true} />
                    </div>
                ) : (
                    <div className="start_start" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                        <Table striped bordered hover style={{ fontSize: "12px" }}>
                            <thead style={{ background: "lightsteelblue", color: "black" }}>
                                <tr>
                                    <th>S.no</th>
                                    <th>Hospital</th>
                                    <th>Data Last Updated</th>
                                    <th>Grand Total Tags</th>
                                    <th>Dicharged Tags</th>
                                    <th>IN Hospital Tags</th>
                                    <th>Active Tags</th>
                                    <th>Strap Removed Tags</th>
                                    <th>Out Gate Tags</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(tcpDataMap).map(([key, mothertagdata], index) => (
                                    <tr key={key}>
                                        <td>{index + 1}</td>
                                        <th>{mothertagdata.hospital_type} {mothertagdata.hospital_code}</th>
                                        <td>{mothertagdata.lastupdated}</td>
                                        <td>{mothertagdata.grandtotalTcp.length}</td>
                                        <td>{mothertagdata.dischargedTCP.length}</td>
                                        <td>{mothertagdata.inhospitalTCP.length}</td>
                                        <td>{mothertagdata.activeTcp.length}</td>
                                        <td>{mothertagdata.strapRemoveTcp.length}</td>
                                        <td>{mothertagdata.outGateTcp.length}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}

            </div>
            <div className="center_center" style={{ background: "#190262" }} >
                <div className="center_center" style={{ width: "80%", flexDirection: "column" }} >
                    <div>
                        <div className="App-link" href="http://maps.google.com/maps?q=loc:17.4630995,78.6093086(Location)" aria-label="Calon Address"
                            style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                            <b style={{ color: "white" }}>Address :</b> CAL-ON Instruments | SY.NO:193| PHASE 4,IDA CHERLAPALLY | HYDERABAD | 500051| INDIA
                        </div>
                    </div>
                    <div>
                        <div className="App-link" href="http://cal-on.com" aria-label="Calon Website"
                            style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                            <b style={{ color: "white" }}>Website :</b> http://cal-on.com
                        </div>
                    </div>
                </div>
                <div className="end_center" style={{ width: "20%" }} >
                    <div href="https://www.youtube.com/" aria-label="youtube"
                        className="youtube social" style={social_style} target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faYoutube} size="1x" />
                    </div>
                    <div href="https://www.facebook.com/" aria-label="facebook"
                        className="facebook social" style={social_style} target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faFacebook} size="1x" />
                    </div>
                    <div href="https://www.twitter.com" aria-label="twitter"
                        className="twitter social" style={social_style} target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faTwitter} size="1x" />
                    </div>
                    <div href="https://www.instagram.com" aria-label="instagram"
                        className="instagram social" style={social_style} target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faInstagram} size="1x" />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AllHospitalsData;

